import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dynamic-table-header"
export default class extends Controller {

	static targets = ['column', 'columnsLabel']

	setColumns(columns) {
		const oldColumns = this.columnTargets

		// at least one dynamic column must be present, to be used for column placement on future setColumns() updates
		if (columns.length == 0) {
			const columnElement = document.createElement('th')
			columnElement.dataset.dynamicTableHeaderTarget = 'column'
			oldColumns[0].before(columnElement)

		} else {
			columns.forEach(column => {
				const columnElement = document.createElement('th')
				columnElement.dataset.dynamicTableHeaderTarget = 'column'
				columnElement.innerText = column['name']
				oldColumns[0].before(columnElement)
			})
		}

		oldColumns.forEach(ct => ct.remove())

		this.updateColumnsLabel(columns)
	}

	updateColumnsLabel(columns) {
		if (this.hasColumnsLabelTarget) {
			this.columnsLabelTarget.colSpan = columns.length
		}
	}

}
